<template>
  <v-layout>
    <!-- Not used? -->
    <v-flex xs10>
      <div style="margin:0 20px;">
        <p>{{ theLabel }}</p>
        <v-textarea outline v-model="value" no-resize :change="onValueChanged"></v-textarea>
      </div>
    </v-flex>
    <v-flex xs2></v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "WesAnswerExplaination",
  props: {
    label: String,
    explaination: String
  },
  computed: {
    value: function () {
      return this.explaination;
    },
    theLabel: function () {
      if (!this.label) { return 'If needed, use the space below to provide clarification for the data reported in this question.'; }
      return this.label;
    }
  },
  methods: {
    onValueChanged: function (event) {
      console.log("On Value Changed.");
    }
  }
};
</script>

<style scoped>
</style>
